import { render, staticRenderFns } from "./MeetingReportAttachments.vue?vue&type=template&id=54996e7c&"
import script from "./MeetingReportAttachments.vue?vue&type=script&lang=js&"
export * from "./MeetingReportAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports